import styled, { css } from 'styled-components';
import { getChipAppearance } from './getChipAppearance.js';
import { getContainerSize, getContentContainerPadding, getChipActionPadding, getIconSize } from './utils.js';
import { Typography } from '../../foundation/Typography/styled.js';
import { pxToRem } from '../../foundation/spacing/utils.js';
import { themeGet } from '../../foundation/theme/themeGet/get.js';
import { interactiveTransition } from '../../foundation/theme/utils.js';
import { AiBorderStackingOrderGuard } from '../../foundation/theme/AiBorderStackingOrderGuard/index.js';

var PrimaryLabel = styled(Typography).withConfig({
  displayName: "PrimaryLabel",
  componentId: "sc-s3goaa-0"
})([""]);
var SecondaryLabel = styled(Typography).withConfig({
  displayName: "SecondaryLabel",
  componentId: "sc-s3goaa-1"
})([""]);
var chipPart = css(["position:relative;display:flex;height:100%;align-items:center;border:none;padding:0;margin:0;background:transparent;border:solid ", ";color:", ";outline:none;&:is(button){cursor:pointer;}", ";"], pxToRem(1), themeGet('color.100'), interactiveTransition);
var ChipAction = styled.button.withConfig({
  displayName: "ChipAction",
  componentId: "sc-s3goaa-2"
})(["", ";margin-left:auto;"], chipPart);
var ChipContent = styled.button.withConfig({
  displayName: "ChipContent",
  componentId: "sc-s3goaa-3"
})(["", ";width:100%;gap:", ";overflow:hidden;"], chipPart, pxToRem(4));
var ChipContainer = styled.div.withConfig({
  displayName: "ChipContainer",
  componentId: "sc-s3goaa-4"
})(["display:flex;align-items:center;max-width:100%;", ";", ",", "{", ";}", "{", ";", ";}", "{", ";}& > *:first-child{border-top-left-radius:", ";border-bottom-left-radius:", ";&:not(:only-child){border-right:none;}}& > *:last-child{border-top-right-radius:", ";border-bottom-right-radius:", ";&:not(:only-child){border-left:none;}}[data-icon='falcon']{display:flex;align-items:center;justify-content:center;aspect-ratio:1 / 1;", ";}"], function (_ref) {
  var $size = _ref.$size;
  return getContainerSize($size);
}, ChipContent, ChipAction, function (_ref2) {
  var $appearance = _ref2.$appearance,
    $variant = _ref2.$variant;
  return getChipAppearance($appearance, $variant);
}, ChipContent, function (_ref3) {
  var $wrap = _ref3.$wrap;
  return !$wrap && "white-space: nowrap;";
}, function (_ref4) {
  var $size = _ref4.$size;
  return getContentContainerPadding($size);
}, ChipAction, function (_ref5) {
  var $size = _ref5.$size;
  return getChipActionPadding($size);
}, pxToRem(8), pxToRem(8), pxToRem(8), pxToRem(8), function (_ref6) {
  var $size = _ref6.$size;
  return getIconSize($size);
});
var StyledAiBorderStackingOrderGuard = styled(AiBorderStackingOrderGuard).withConfig({
  displayName: "StyledAiBorderStackingOrderGuard",
  componentId: "sc-s3goaa-5"
})(["display:flex;flex-flow:nowrap;max-width:100%;height:100%;"]);

export { ChipAction, ChipContainer, ChipContent, PrimaryLabel, SecondaryLabel, StyledAiBorderStackingOrderGuard };
